import { darken, lighten } from '@mui/material'

const primaryMain = '#005E66'
const secondaryMain = '#D4E9E2'

export const primary = {
  light: lighten(primaryMain, 0.25),
  main: primaryMain,
  dark: darken(primaryMain, 0.25)
}

export const secondary = {
  light: lighten(secondaryMain, 0.25),
  main: secondaryMain,
  dark: darken(secondaryMain, 0.25),
  contrastText: '#000'
}

export const neutral = '#F9F9F9'

export const highlighted = '#ECC704'

export const noDataColor = '#BFBFBF'
export const storeComplianceColors = {
  compliant: '#34802D',
  nonCompliant: highlighted,
  noData: noDataColor
}
